function openInquiryWindow(url) {
  window.open(url, 'inquiry', 'width=980, height=800, menubar=no, toolbar=no, scrollbars=yes');
}
window.openInquiryWindow = openInquiryWindow;



// WEBPACK FOOTER //
// ./es6/user-common-js/ui/legacy/inquiry.js